import Vue from 'vue';
import { isRawFile, RawDevelopSettings } from '@/service/rawConverter';

interface ConfirmationRequest {
    files: File[];
    rawCount: number;
    resolve: (decision: RawConversionDecision) => void;
}

export const rawConversionConfirmationBus = new Vue();

export interface RawConversionDecision {
    confirmed: boolean;
    advanced: boolean;
    settingsByFile?: Map<File, RawDevelopSettings>;
}

export const CANCELLED_RAW_CONVERSION: RawConversionDecision = {
    confirmed: false,
    advanced: false,
};

export function confirmRawConversion(files: File[]): Promise<RawConversionDecision> {
    const rawCount = files.filter(isRawFile).length;
    if (rawCount === 0) {
        return Promise.resolve({
            confirmed: true,
            advanced: false,
        });
    }

    return new Promise<RawConversionDecision>((resolve) => {
        rawConversionConfirmationBus.$emit('request', {
            files,
            rawCount,
            resolve,
        } as ConfirmationRequest);
    });
}

export async function waitForRawConversionDialogClose(files: File[]): Promise<void> {
    if (!files.some(isRawFile)) {
        return;
    }

    // Vuetify keeps the dialog overlay mounted during its leave transition.
    // Let it finish before opening a following dialog (usually watermark settings).
    await new Promise((resolve) => window.setTimeout(resolve, 350));
}
